module.exports = __webpack_public_path__ + "media/src/assets/Images/GooglePlayButtonImage-241e21c7f216c45132d6f2fe046309f1.svg";